/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentInCompanySpaceUpgradeResponseOwningCompanySpace } from './ContentInCompanySpaceUpgradeResponseOwningCompanySpace';
import {
    ContentInCompanySpaceUpgradeResponseOwningCompanySpaceFromJSON,
    ContentInCompanySpaceUpgradeResponseOwningCompanySpaceFromJSONTyped,
    ContentInCompanySpaceUpgradeResponseOwningCompanySpaceToJSON,
} from './ContentInCompanySpaceUpgradeResponseOwningCompanySpace';
import type { ContentViewerItem } from './ContentViewerItem';
import {
    ContentViewerItemFromJSON,
    ContentViewerItemFromJSONTyped,
    ContentViewerItemToJSON,
} from './ContentViewerItem';
import type { ContentViewerShowResponseContentVersion } from './ContentViewerShowResponseContentVersion';
import {
    ContentViewerShowResponseContentVersionFromJSON,
    ContentViewerShowResponseContentVersionFromJSONTyped,
    ContentViewerShowResponseContentVersionToJSON,
} from './ContentViewerShowResponseContentVersion';

/**
 * Content viewer
 * @export
 * @interface ContentViewerUpdateResponse
 */
export interface ContentViewerUpdateResponse {
    /**
     * 
     * @type {number}
     * @memberof ContentViewerUpdateResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ContentViewerUpdateResponse
     */
    state: string;
    /**
     * 
     * @type {number}
     * @memberof ContentViewerUpdateResponse
     */
    time_estimation: number;
    /**
     * 
     * @type {number}
     * @memberof ContentViewerUpdateResponse
     */
    percent_done: number;
    /**
     * 
     * @type {Date}
     * @memberof ContentViewerUpdateResponse
     */
    created_at: Date;
    /**
     * 
     * @type {number}
     * @memberof ContentViewerUpdateResponse
     */
    user_id: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContentViewerUpdateResponse
     */
    is_preview: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContentViewerUpdateResponse
     */
    is_marketplace_preview: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContentViewerUpdateResponse
     */
    marketplace_offer_slug: string;
    /**
     * 
     * @type {string}
     * @memberof ContentViewerUpdateResponse
     */
    marketplace_offer_url: string;
    /**
     * 
     * @type {string}
     * @memberof ContentViewerUpdateResponse
     */
    lock_reason: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContentViewerUpdateResponse
     */
    user_can_edit_version: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContentViewerUpdateResponse
     */
    confirmed_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentViewerUpdateResponse
     */
    completed_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContentViewerUpdateResponse
     */
    certificate_available: boolean;
    /**
     * 
     * @type {ContentViewerItem}
     * @memberof ContentViewerUpdateResponse
     */
    current_lesson?: ContentViewerItem;
    /**
     * 
     * @type {ContentViewerItem}
     * @memberof ContentViewerUpdateResponse
     */
    current_step?: ContentViewerItem;
    /**
     * 
     * @type {Array<ContentInCompanySpaceUpgradeResponseOwningCompanySpace>}
     * @memberof ContentViewerUpdateResponse
     */
    company_spaces?: Array<ContentInCompanySpaceUpgradeResponseOwningCompanySpace>;
    /**
     * 
     * @type {ContentViewerShowResponseContentVersion}
     * @memberof ContentViewerUpdateResponse
     */
    content_version?: ContentViewerShowResponseContentVersion;
}

/**
 * Check if a given object implements the ContentViewerUpdateResponse interface.
 */
export function instanceOfContentViewerUpdateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "time_estimation" in value;
    isInstance = isInstance && "percent_done" in value;
    isInstance = isInstance && "created_at" in value;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "is_preview" in value;
    isInstance = isInstance && "is_marketplace_preview" in value;
    isInstance = isInstance && "marketplace_offer_slug" in value;
    isInstance = isInstance && "marketplace_offer_url" in value;
    isInstance = isInstance && "lock_reason" in value;
    isInstance = isInstance && "user_can_edit_version" in value;
    isInstance = isInstance && "certificate_available" in value;

    return isInstance;
}

export function ContentViewerUpdateResponseFromJSON(json: any): ContentViewerUpdateResponse {
    return ContentViewerUpdateResponseFromJSONTyped(json, false);
}

export function ContentViewerUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentViewerUpdateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'state': json['state'],
        'time_estimation': json['time_estimation'],
        'percent_done': json['percent_done'],
        'created_at': (new Date(json['created_at'])),
        'user_id': json['user_id'],
        'is_preview': json['is_preview'],
        'is_marketplace_preview': json['is_marketplace_preview'],
        'marketplace_offer_slug': json['marketplace_offer_slug'],
        'marketplace_offer_url': json['marketplace_offer_url'],
        'lock_reason': json['lock_reason'],
        'user_can_edit_version': json['user_can_edit_version'],
        'confirmed_at': !exists(json, 'confirmed_at') ? undefined : json['confirmed_at'],
        'completed_at': !exists(json, 'completed_at') ? undefined : json['completed_at'],
        'certificate_available': json['certificate_available'],
        'current_lesson': !exists(json, 'current_lesson') ? undefined : ContentViewerItemFromJSON(json['current_lesson']),
        'current_step': !exists(json, 'current_step') ? undefined : ContentViewerItemFromJSON(json['current_step']),
        'company_spaces': !exists(json, 'company_spaces') ? undefined : ((json['company_spaces'] as Array<any>).map(ContentInCompanySpaceUpgradeResponseOwningCompanySpaceFromJSON)),
        'content_version': !exists(json, 'content_version') ? undefined : ContentViewerShowResponseContentVersionFromJSON(json['content_version']),
    };
}

export function ContentViewerUpdateResponseToJSON(value?: ContentViewerUpdateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'state': value.state,
        'time_estimation': value.time_estimation,
        'percent_done': value.percent_done,
        'created_at': (value.created_at.toISOString()),
        'user_id': value.user_id,
        'is_preview': value.is_preview,
        'is_marketplace_preview': value.is_marketplace_preview,
        'marketplace_offer_slug': value.marketplace_offer_slug,
        'marketplace_offer_url': value.marketplace_offer_url,
        'lock_reason': value.lock_reason,
        'user_can_edit_version': value.user_can_edit_version,
        'confirmed_at': value.confirmed_at,
        'completed_at': value.completed_at,
        'certificate_available': value.certificate_available,
        'current_lesson': ContentViewerItemToJSON(value.current_lesson),
        'current_step': ContentViewerItemToJSON(value.current_step),
        'company_spaces': value.company_spaces === undefined ? undefined : ((value.company_spaces as Array<any>).map(ContentInCompanySpaceUpgradeResponseOwningCompanySpaceToJSON)),
        'content_version': ContentViewerShowResponseContentVersionToJSON(value.content_version),
    };
}

